const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Default configurations that don't require secrets
const DEFAULT_CONFIG = {
    staging: {
        cognitoClientId: process.env.REACT_APP_DEVELOPMENT_COGNITO_CLIENT_ID,
        loginDomain: process.env.REACT_APP_DEVELOPMENT_LOGIN_DOMAIN,
        redirectUri: process.env.REACT_APP_DEVELOPMENT_REDIRECT_URI,
        region: process.env.REACT_APP_DEVELOPMENT_REGION
    },
    development: {
        cognitoClientId: process.env.REACT_APP_DEVELOPMENT_COGNITO_CLIENT_ID,
        loginDomain: process.env.REACT_APP_DEVELOPMENT_LOGIN_DOMAIN,
        redirectUri: process.env.REACT_APP_DEVELOPMENT_REDIRECT_URI,
        region: process.env.REACT_APP_DEVELOPMENT_REGION
    },
    production: {
        cognitoClientId: process.env.REACT_APP_PRODUCTION_COGNITO_CLIENT_ID,
        loginDomain: process.env.REACT_APP_PRODUCTION_LOGIN_DOMAIN,
        redirectUri: process.env.REACT_APP_PRODUCTION_REDIRECT_URI,
        region: process.env.REACT_APP_PRODUCTION_REGION
    }
};

// Get the environment-specific config
const getEnvConfig = () => {
    if (isProduction) {
        return DEFAULT_CONFIG.production;
    } else if (process.env.REACT_APP_ENV === 'STAGING') {
        return DEFAULT_CONFIG.staging;
    }
    return DEFAULT_CONFIG.development;
    
};

// Synchronous function to get login URL
export const getLoginUrl = () => {
    const config = getEnvConfig();
    const scopes = [
        'aws.cognito.signin.user.admin',
        'email',
        'openid',
        'phone',
        'profile'
    ].join(' ');

    const params = new URLSearchParams({
        client_id: config.cognitoClientId,
        response_type: 'code',
        scope: scopes,
        redirect_uri: config.redirectUri
    });

    return `https://${config.loginDomain}/login?${params.toString()}`;
};

// Synchronous function to get sign out URL
export const getSignOutUrl = () => {
    const config = getEnvConfig();
    const params = new URLSearchParams({
        client_id: config.cognitoClientId,
        logout_uri: config.signOutUri
    });

    return `https://${config.loginDomain}/logout?${params.toString()}`;
};

// Synchronous function to get basic Cognito config
export const getCognitoConfig = () => {
    const config = getEnvConfig();
    return {
        region: config.region,
        clientId: config.cognitoClientId
    };
};


// Export the default config for the current environment
export default getEnvConfig(); 